<router-outlet></router-outlet>
<!-- <ngx-alerts></ngx-alerts> -->
<ngx-spinner
  type="ball-fussion"
  color="#FF8065"
  bdColor="rgba(0, 0, 0, 0)"
></ngx-spinner>
